<template>
		<dropdown-menu v-model="show" :right="right" :hover="hover">
        <button class="btnDrop">
            <span class="nomLangSelected">
              {{lang}}
            </span>
        </button>
        <div slot="dropdown" class="dropdown-menu-lang">
          <div class="dropdown-item" @click="ChangeLang('es')">
            <a class="text-left noactive" >
              <img alt="spain" src="@/core/assets/img/flag-spain.png"  style="height:20px;"> Spanish
              <b class="badge badge-success"  v-if="lang == 'es'" style="margin:5px;font-size:9px;float:right;">
                <i class="fa fa-check"></i>
              </b>
            </a>
          </div>
          <div class="dropdown-item" @click="ChangeLang('en')">
            <a class="text-left active" >
              <img alt="usa" src="@/core/assets/img/flag-usa.png"  style="height:20px;"> Inglish
              <b class="badge badge-success"  v-if="lang == 'en'" style="margin:5px;font-size:9px;float:right;">
                <i class="fa fa-check"></i>
              </b>
            </a>
          </div>
        </div>
      </dropdown-menu>
</template>

<script>
    import DropdownMenu from '@innologica/vue-dropdown-menu'
    export default {
        name: 'menuLang',
        components: {
            DropdownMenu
        },
        props: {
            langUpdate: {
                type: String,
                default: 'en'
            }
        },
        data () {
            return {
                show: false,
                right: true,
                hover: false,
                lang: this.langUpdate,
            }
        },
        methods: {
            ChangeLang(langEvent){
              this.lang = langEvent;
              this.$emit('saveLang', langEvent);
            },
        },
        watch: {
            langUpdate(newLang) {
                this.lang = newLang;
            }
        }
    };
</script>

<style lang="css" scoped>
.btnDrop {
    border: 0;
    background-color: transparent;
    color: #fff;
    height: 30px;
    cursor: pointer;
    margin-left: 10px;
    border: 1px solid #fff;
    border-radius: 4px;
}
.nomLangSelected{
    font-size: 14px;
    color: #fff;
    text-transform: capitalize;
}
</style>
